import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GENDERS } from '../constants';

const useGenderOptions = () => {
  const { t } = useTranslation('scout');

  return useMemo(
    () => [
      {
        label: t('all'),
        value: GENDERS.ALL,
      },
      {
        label: t('male'),
        value: GENDERS.MALE,
      },
      {
        label: t('female'),
        value: GENDERS.FEMALE,
      },
      {
        label: t('other'),
        value: GENDERS.OTHER,
      },
    ],
    [t],
  );
};

export default useGenderOptions;
